import React from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { setInterval } from '@store/overviewDashboard/base/actions';
import { getDateShortcuts, shouldHide } from './dateUtils';
import { DateText, DisabledDate } from '@components/common/date-picker-v2/styled';

const Shorcuts = ({
  selectedInterval, overviewDate, tzOffset,
}) => {
  const dispatch = useDispatch();
  const shortcuts = getDateShortcuts();

  const getShortcuts = () => {
    const elements = shortcuts.map(([shortcut, interval], index) => {
      const isDisabled = shouldHide(interval[0], overviewDate, tzOffset, shortcut);

      const onChangeOfShortcut = () => {
        const currentInterval = {
          from: moment(interval[0]).format(),
          to: moment(interval[1]).format(),
          shortcut,
        };

        dispatch(setInterval({ interval: currentInterval }));
      };

      if (isDisabled) {
        return (
          <React.Fragment key={index}>
            <DisabledDate>
              {shortcut}
            </DisabledDate>
          </React.Fragment>
        );
      }

      const isSelected = selectedInterval.shortcut === shortcut;
      return (
        <React.Fragment key={index}>
          <DateText className={isSelected ? 'active' : ''} selected={isSelected} onClick={onChangeOfShortcut}>
            {shortcut}
          </DateText>
        </React.Fragment>
      );
    });
    return elements;
  };

  return <>{getShortcuts()}</>;
};

export default Shorcuts;
